import useTemplateVariables from 'components/domain/customData/useTemplateVariables';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';
import { MessagingType } from 'models/automation/SystemTemplates';
import { CUSTOM_TEMPLATE_VARIABLE_TYPES } from '../CustomTemplatesTab.constants';

interface UseCustomTemplateToolbarSettingsProps {
  loadPreview: (content: string) => Promise<string>;
  messagingType?: MessagingType;
  onEnterPreviewMode: () => void;
  onExitPreviewMode: () => void;
}

const useCustomTemplateToolbarSettings = ({
  loadPreview,
  messagingType,
  onEnterPreviewMode,
  onExitPreviewMode,
}: UseCustomTemplateToolbarSettingsProps) => {
  const isEmailType = messagingType === MessagingType.EMAIL;

  const { variables, isLoading: isLoadingVariables } = useTemplateVariables(
    CUSTOM_TEMPLATE_VARIABLE_TYPES,
  );

  const toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'] = {
    enabled: true,
    features: {
      bold: isEmailType,
      cleanHTML: isEmailType,
      editHTML: isEmailType,
      fontFamily: isEmailType,
      italic: isEmailType,
      link: isEmailType,
      lists: isEmailType,
      preview: {
        loadPreview,
        onEnterPreviewMode,
        onExitPreviewMode,
      },
      quote: isEmailType,
      textAlignment: isEmailType,
      textColor: isEmailType,
      underline: isEmailType,
      variables,
    },
  };

  return {
    toolbarSettings,
    isLoadingVariables,
  };
};

export default useCustomTemplateToolbarSettings;
